import React, { ReactNode } from 'react';
import { GridItem } from '@chakra-ui/react';
import { TTemplate } from '@/helpers/createTemplate';
import {
  GridWrapper,
  BoxAside,
  BoxContent,
} from '../styles/OnboardingLayout.styles';
import { EOnboardingPageType } from '../OnboardingWrapper.types';
import CloseButton from '../components/CloseButton';

const template = (
  children: ReactNode,
  aside?: ReactNode,
  pageType?: EOnboardingPageType
): TTemplate => ({
  wrapper: <GridWrapper />,
  aside: (
    <GridItem gridArea="aside" className="bc-aside-item">
      <BoxAside className="bc-aside">{aside}</BoxAside>
    </GridItem>
  ),
  content: (
    <GridItem gridArea="content" className="bc-content-item">
      <BoxContent className="bc-content" pageType={pageType}>
        {children}
      </BoxContent>
    </GridItem>
  ),
  closeButton: <CloseButton />,
});

export default template;
